import React, { useState } from 'react';
import { Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Typography } from 'antd';
import { user$ } from '../services/auth-service';
import { UserModel } from '../models/user-model';
import { useObservable } from 'rxjs-hooks';
import { LoginOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;


function IntroPage() {
    const navigate = useNavigate();
    const currentUser : UserModel|undefined = useObservable(user$, undefined);
    
    return (
        <div style={{maxWidth:1000,margin:"0 auto", position:'relative', zIndex:1,height:'95%'}}>
            <div className="bg"></div>
            <Title style={{textAlign:'center'}}><div>BASQAR</div><div>Insightful Decision Support for Airborne Emissions</div></Title>
            <Paragraph>
                BASQAR is a proprietary decision support system designed specifically for QatarEnergy-LNG. Developed by Texas A&M University at Qatar, it serves as a powerful tool to evaluate and predict the impact of airborne emissions. The platform, embodying the pricinple of combining information and knowledge with action (QED "by failing to prepare you are preparing to fail") offers seamless access to real-time forecasts, historical scenario analyses, and actionable insights, empowering users to optimize environmental performance and compliance.
            </Paragraph>

            <Paragraph>
                BASQAR represents a significant step forward in environmental management, combining advanced research and technology to meet QatarEnergy-LNG's commitment to sustainable operations.
            </Paragraph>
            
            <div style={{textAlign:'center',marginTop:30}}>
                {!currentUser ? 
                    <Button size='large' icon={<LoginOutlined/>} type='primary' onClick={()=>navigate('/login')}>Login</Button>: 
                    <Space>
                    <Button size='large' type='primary' onClick={()=>navigate('/scenaria-player')}>Scenaria player</Button>
                    {currentUser.roles.find(r=>r.name === 'admin') &&<>
                        <Button size='large' type='default' onClick={()=>navigate('/scenaria-admin')}>Scenaria management</Button>
                        <Button size='large' type='default' onClick={()=>navigate('/users-list')}>User management</Button>
                    </>}
                    </Space>
                }
            </div>
        </div>
    );
}
//'/scenaria-player?scenarioId=7'
export default IntroPage;